import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { LoadingGrid } from 'components/interface/Loading';
import App from 'pages/App';
import Page from 'components/Page';
import TimesheetView from 'components/Content/assignment/report/View';
import useDocumentTitle from 'components/hooks/useDocumentTitle';

export default function AssignmentTimesheetPage() {
    useDocumentTitle('Tidrapport');
    const { id } = useParams();
    return (
        <App>
            <Page>
                <Suspense fallback={<LoadingGrid />}>
                    {id ? <TimesheetView assignmentID={id} /> : <LoadingGrid />}
                </Suspense>
            </Page>
        </App>
    );
}
